export default {
    title: 'http',
    baseUrl: {
      dev: '/prod-api',//开发后的地址
      pro: null//上线后的地址
    },
  }